import controller from './main-menu.controller';
import template from './main-menu.view.html';

let MainMenuComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MainMenuComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/main-menu/main-menu.component.js
 **/